<template>
  <b-modal
    ref="itemsForShippingModal"
    :title="$t('shipments.modal.addToShipments')"
    centered
    modal-class="items-shipping-modal"
  >
    <b-row>
      <b-col>
        <div class="making-zone px-2">
          <b-row class="mb-3">
            <b-col>
              <b-row class="d-flex align-items-center">
                <b-col cols="auto">
                  <span class="dark">{{ $t('shipments.modal.shipmentType') }}:</span>
                </b-col>
                <b-col cols="5">
                  <vt-combo-select
                    v-model="shipmentTypeSelected"
                    v-validate="'required'"
                    track-by="value"
                    :options="shipmentTypes"
                    label="label"
                    :name="$t('shipments.modal.shipmentType')"
                    :allow-empty="false"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col class="d-flex justify-content-end">
              <div>
                <i
                  class="far fa-box main mr-2"
                  aria-hidden="true"
                />
                <span class="title">{{ elements.length }} {{ $tc('shipments.modal.element', elements.length) }} {{ $t('shipments.modal.toSend') }}</span>
              </div>
            </b-col>
          </b-row>
          <b-row class="items-zone mx-0">
            <!--                        TODO: Sección oculta de momento, a falta de revisión final.-->
            <!--                        <b-col cols="4" class="elements-column p-2">-->
            <!--                            &lt;!&ndash;Case zone&ndash;&gt;-->
            <!--                            <div v-for="(caseItem, index) in casesTree" :key="index">-->
            <!--                                &lt;!&ndash; TODO: la clase "caseActived" debe añadirse solo para resaltar estudios, cuando haces click en la tarjeta. Esto hace que cambie la vista de la columna derecha &ndash;&gt;-->
            <!--                                <div class="item case py-1 px-2 d-flex justify-content-between" :class="{'active': caseActive}">-->
            <!--                                    <div class="selection d-flex align-items-center">-->
            <!--                                        <i class="entity-icon far fa-chart-network mr-2" aria-hidden="true"></i>-->
            <!--                                        <span class="entity-label">{{ caseItem.name }}</span>-->
            <!--                                    </div>-->
            <!--                                    <div class="d-flex align-items-center">-->
            <!--                                        <div>-->
            <!--                                            <vtBubble-->
            <!--                                                :number="2"-->
            <!--                                                :info="true"-->
            <!--                                            />-->
            <!--                                        </div>-->
            <!--                                        <button type="button" class=" btn btn__icon btn__icon--primary mx-2 p-0"><i class="far fa-chevron-down" aria-hidden="true"></i></button>-->
            <!--                                        &lt;!&ndash; TODO: Hacer que el botón cambie por el siguiente al abrirse el árbol &ndash;&gt;-->
            <!--                                        &lt;!&ndash;<button type="button" class=" btn btn__icon btn__icon--primary mx-2 p-0"><i class="far fa-chevron-up" aria-hidden="true"></i></button>&ndash;&gt;-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                                &lt;!&ndash;Samples zone&ndash;&gt;-->
            <!--                                <div v-for="(sampleItem, index) in caseItem.samples" :key="index">-->
            <!--                                    <div class="item sample py-1 px-2 d-flex justify-content-between">-->
            <!--                                        <div class="selection d-flex align-items-center">-->
            <!--                                            <i class="entity-icon far fa-prescription-bottle mr-2" aria-hidden="true"></i>-->
            <!--                                            <span class="entity-label">{{ sampleItem.name }}</span>-->
            <!--                                        </div>-->
            <!--                                        <div>-->
            <!--                                            <button type="button" class=" btn btn__icon btn__icon--primary mx-2 p-0"><i class="far fa-chevron-down" aria-hidden="true"></i></button>-->
            <!--                                            &lt;!&ndash; TODO: Hacer que el botón cambie por el siguiente al abrirse el árbol &ndash;&gt;-->
            <!--                                            &lt;!&ndash;<button type="button" class=" btn btn__icon btn__icon--primary mx-2 p-0"><i class="far fa-chevron-up" aria-hidden="true"></i></button>&ndash;&gt;-->
            <!--                                        </div>-->
            <!--                                    </div>-->
            <!--                                    &lt;!&ndash;Portion zone&ndash;&gt;-->
            <!--                                    <div v-for="(portionItem, index) in sampleItem.portions" :key="index">-->
            <!--                                        <div class="item portion py-1 px-2 d-flex justify-content-between">-->
            <!--                                            <div class="selection d-flex align-items-center">-->
            <!--                                                <i class="entity-icon icon-block mr-2" aria-hidden="true"></i>-->
            <!--                                                <span class="entity-label">{{ portionItem.name }}</span>-->
            <!--                                            </div>-->
            <!--                                            <div>-->
            <!--                                                <button type="button" class=" btn btn__icon btn__icon--primary mx-2 p-0"><i class="far fa-chevron-down" aria-hidden="true"></i></button>-->
            <!--                                                &lt;!&ndash; TODO: Hacer que el botón cambie por el siguiente al abrirse el árbol &ndash;&gt;-->
            <!--                                                &lt;!&ndash;<button type="button" class=" btn btn__icon btn__icon--primary mx-2 p-0"><i class="far fa-chevron-up" aria-hidden="true"></i></button>&ndash;&gt;-->
            <!--                                            </div>-->
            <!--                                        </div>-->
            <!--                                        &lt;!&ndash;Subportion zone&ndash;&gt;-->
            <!--                                        <div v-for="(subportionItem, index) in portionItem.subportions" :key="index">-->
            <!--                                            <div class="item subportion py-1 px-2 d-flex justify-content-between">-->
            <!--                                                <div class="selection d-flex align-items-center">-->
            <!--                                                    <i class="entity-icon icon-porta mr-2" aria-hidden="true"></i>-->
            <!--                                                    <span class="entity-label">{{ subportionItem.name }}</span>-->
            <!--                                                </div>-->
            <!--                                            </div>-->
            <!--                                        </div>-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                            </div>-->
            <!--                        </b-col>-->
            <b-col>
              <div class="mt-3">
                <b-row v-if="!isExternal">
                  <b-col>
                    <div class="form-label">
                      <label>{{ $t('shipments.grid.destinationPathologist') }}</label>
                    </div>
                    <vt-combo-select
                      v-model="pathologistSelected"
                      :options="pathologistsList"
                      label="fullName"
                      class="nowrap"
                    />
                  </b-col>
                  <!--                                    TODO: Pendiente de análisis-->
                  <!--                                    <b-col>-->
                  <!--                                        <div class="form-label">-->
                  <!--                                            <label>{{ $t('shipments.grid.destinationSpecialist') }}</label>-->
                  <!--                                        </div>-->
                  <!--                                        <vt-combo-select v-model="selected" track-by="value"-->
                  <!--                                                         :options="options" label="text"-->
                  <!--                                                         name="openBy"-->
                  <!--                                                         v-validate="'required'"/>-->
                  <!--                                    </b-col>-->
                </b-row>
                <ShipmentItemsList
                  :elements="elements"
                  :is-external="isExternal"
                />
              </div>
            </b-col>
          </b-row>
          <context-menu
            id="context-menu"
            ref="ctxMenu"
          >
            <div class="context-header">
              {{ $t('shipments.modal.return') }}
            </div>
            <div>{{ $tc('shipments.modal.element', 1) }}</div>
            <div>{{ $t('shipments.modal.generatedElements') }}</div>
            <div>{{ $t('shipments.modashipmentTypeSelectedl.all') }}</div>
            <hr class="my-0">
            <div>{{ $t('shipments.modal.noReturn') }}</div>
          </context-menu>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="shipping-box p-3">
          <div class="mb-2 d-flex justify-content-between">
            <div>
              <i
                class="far fa-compass main mr-2"
                aria-hidden="true"
              />
              <span class="title">{{ $t('shipments.grid.destination') }}</span>
            </div>
            <div v-if="isExternal">
              <button
                v-tooltip="$t('shipments.modal.saveAddress')"
                type="button"
                class="btn btn__icon btn__icon--primary mx-2 p-0"
                @click="$refs.saveAddressModal.show()"
              >
                <i
                  class="far fa-save"
                  aria-hidden="true"
                />
              </button>
              <button
                v-tooltip="$t('shipments.modal.addressBook')"
                type="button"
                class="btn btn__icon btn__icon--primary mx-2 p-0"
                @click="$refs.addressBookModal.show()"
              >
                <i
                  class="far fa-book-alt"
                  aria-hidden="true"
                />
              </button>
            </div>
          </div>
          <b-row v-if="isExternal">
            <b-col
              cols="4"
              class="mb-3"
            >
              <div class="form-label">
                <label>{{ $t('shipments.modal.centerName') }}</label>
              </div>
              <vt-input class="form-control-sm" />
            </b-col>
            <b-col
              cols="8"
              class="mb-3"
            >
              <div class="form-label">
                <label>{{ $t('shipments.modal.address') }}</label>
              </div>
              <vt-input class="form-control-sm" />
            </b-col>
            <b-col cols="3">
              <div class="form-label">
                <label>{{ $t('shipments.modal.postalCode') }}</label>
              </div>
              <vt-input class="form-control-sm" />
            </b-col>
            <b-col cols="3">
              <div class="form-label">
                <label>{{ $t('shipments.modal.province') }}</label>
              </div>
              <vt-input class="form-control-sm" />
            </b-col>
            <b-col cols="3">
              <div class="form-label">
                <label>{{ $t('shipments.modal.country') }}</label>
              </div>
              <vt-input class="form-control-sm" />
            </b-col>
            <b-col cols="3">
              <div class="form-label">
                <label>{{ $t('shipments.modal.contactTelephone') }}</label>
              </div>
              <vt-input class="form-control-sm" />
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col>
              <div class="form-label">
                <label>{{ $t('shipments.grid.destinationCenter') }}</label>
              </div>
              <vt-combo-select
                v-model="destinationCenterSelected"
                v-validate="'required'"
                :options="destinationCenters"
                label="labName"
                :allow-empty="false"
                open-direction="top"
              />
            </b-col>
            <b-col>
              <div class="form-label">
                <label>{{ $t('global.observations') }}</label>
              </div>
              <b-form-textarea
                no-resize
                max-rows="2"
              />
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            size="sm"
            class="btn--primary"
            :disabled="!destinationCenterSelected"
            @click="send"
          >
            <i
              class="icon-box-send mr-2"
              aria-hidden="true"
            />
            {{ $t('shipments.actions.sendNow') }}
          </b-button>
        </div>
      </div>
    </div>
    <address-book-modal ref="addressBookModal" />
    <save-address-modal ref="saveAddressModal" />
  </b-modal>
</template>

<script>
import { StoreUtils } from '@/shared/util/store-utils'
import AddressBookModal from '@/modules/shipments-module/old/views/components/AddressBookModal'
import SaveAddressModal from '@/modules/shipments-module/old/views/components/SaveAddressModal'
import { requestShipmentServices } from '@/api/resources/shipments/requestShipment/RequestShipmentServices'
import contextMenu from 'vue-context-menu'
import i18n from '@/lang/i18n'
import { SHIPMENT_COREENTITY_VALUES } from '@/modules/shipments-module/old/constants/shipmentCoreEntities'
import { personnelService } from '@/api/resources/personnelService'
import ShipmentItemsList from '@/modules/shipments-module/old/views/components/ShipmentItemsList'
import shipmentsMixin from '@/modules/shipments-module/old/mixins/shipmentsMixin'
import { CommonResponsibilityCodeEnum } from '@/api/services/common/responsibility/common-responsibility.dto'

const SHIPMENT_TYPES = {
    INTERNAL: { value: 'internal', label: i18n.t('shipments.shipmentTypes.internal') },
    EXTERNAL: { value: 'external', label: i18n.t('shipments.shipmentTypes.external') }
}

export default {
    name: 'ItemsForShippingModal',
    components: {
        contextMenu,
        AddressBookModal,
        SaveAddressModal,
        ShipmentItemsList
    },
    mixins: [ shipmentsMixin ],
    props: {
        samples: Array,
        portions: Array,
        subportions: Array,
        casId: Number,
        isCaseValidated: Boolean,
        labId: Number,
        samId: Number
    },
    data() {
        return {
            caseActive: true,
            shipmentTypeSelected: { value: SHIPMENT_TYPES.INTERNAL.value, label: SHIPMENT_TYPES.INTERNAL.label },
            shipmentTypes: [
                { value: SHIPMENT_TYPES.INTERNAL.value, label: SHIPMENT_TYPES.INTERNAL.label }
            ],
            casesTree: [
                { name: 'H1A20-000001',
                    samples: [
                        { name: 'A',
                            portions: [
                                { name: 'A-1',
                                    subportions: [
                                        { name: 'A-1-1' },
                                        { name: 'A-1-2' }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            elements: [],
            destinationCenterSelected: null,
            pathologistSelected: null,
            destinationCenters: [],
            pathologistsList: [],
            portionTypes: []
        }
    },
    computed: {
        isExternal() {
            return this.shipmentTypeSelected.value === SHIPMENT_TYPES.EXTERNAL.value
        }
    },
    watch: {
        async destinationCenterSelected() {
            this.pathologistsList = this.destinationCenterSelected ? await this.getPersonnelPathologist(this.destinationCenterSelected.labId) : []
        }
    },
    methods: {
        async getPersonnelPathologist(labId) {
            const [err, response] = await this.toCall(personnelService.getPersonnelByLaboratoryAndResponsibility(labId, CommonResponsibilityCodeEnum.PATHOLOGIST))
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            return response
        },
        send() {
            this.elements.forEach(async element => {
                // TODO: Hacer en back endpoint para batch
                let request = {
                    caseId: this.casId,
                    coreEntity: element.entity.code,
                    destinationExternalLaboratory: null,
                    destinationExternalPathologist: null,
                    destinationLaboratoryId: this.destinationCenterSelected.labId,
                    isExternal: this.isExternal,
                    isReturn: false,
                    maxReturnDate: null,
                    pathologistPersonnelId: this.pathologistSelected ? this.pathologistSelected.id : null,
                    returnRequired: false
                }
                if (element.entity === SHIPMENT_COREENTITY_VALUES.SAMPLE) {
                    request.caseId = element.caseId
                    request.sampleId = element.id
                } else if (element.entity === SHIPMENT_COREENTITY_VALUES.PORTION) {
                    request.sampleId = element.sampleId
                    request.portionId = element.id
                } else if (element.entity === SHIPMENT_COREENTITY_VALUES.SUBPORTION) {
                    request.sampleId = element.sampleId
                    request.portionId = element.portionId
                    request.subportionId = element.id
                }

                const response =
                    await this.$_toCallUnique(
                        requestShipmentServices.createShippingRequest(request, this.labId))
                if (response != null) {
                    this.$_showSuccessModal(this.$tc('shipments.toastMessages.requestSent'))
                    this.hide()
                }
            })
        },
        show() {
            this.destinationCenterSelected = null
            this.pathologistSelected = null
            this.pathologistsList = []
            this.destinationCenters = StoreUtils.laboratories.filter(lab => lab.labId !== this.labId)
            this.elements = this.generateElementsByEntity(this.samples, this.portions, this.subportions, this.casId, this.samId)
            this.$refs.itemsForShippingModal.show()
        },
        hide() {
            this.$refs.itemsForShippingModal.hide()
        },
        openContextMenu() {
            this.$refs.ctxMenu.open()
        }
    }
}
</script>

<style lang="scss">
    .items-zone {
        border: 1px solid vt-color(grid-general-border);
    }
    .elements-column {
        background: #f7f7f7;
        border-right: 1px solid vt-color(grid-general-border);
        height: calc(100vh - 650px);
        max-width: 250px !important;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .elements-column .item {
        background: vt-color(white);
        box-shadow: 0 1px 1px 0 rgba(141, 141, 143, 0.3);
        border: 1px solid #dee2e6;
        border-radius: 5px;
        margin-bottom: 5px;
        font-size: font-size(small);
        transition: .3s;
    }
    .elements-column .item:hover {
        background: vt-color(light-primary);
        border-color: vt-color(alt-primary, .5);
    }
    .elements-column .item.case.active {
        background: vt-color(primary);
        border-color: vt-color(primary) !important;
    }
    .elements-column .item.case.active i,
    .elements-column .item.case.active span {
        color: vt-color(white-light) !important;
    }
    .elements-column .item .selection {
        cursor: pointer;
        width: 80%;
     }
    .elements-column .item .selection:hover span {
        color: vt-color(primary);
    }
    .elements-column .item .entity-icon {
        color: vt-color(primary);
    }
    .elements-column .item .entity-label {
        color: vt-color(dark-text);
    }
    .elements-column .item.sample {
        margin-left: 10px;
    }
    .elements-column .item.portion {
        margin-left: 20px;
    }
    .elements-column .item.subportion {
        margin-left: 30px;
    }
    .items-shipping-modal .save-address-modal .modal-dialog {
        max-width: 400px !important;
    }
    .items-shipping-modal .address-book .modal-dialog {
        max-width: 60% !important;
    }
    .items-shipping-modal .modal-dialog {
        max-width: 55% !important;
    }
    .items-shipping-modal .making-zone .title {
        color: vt-color(primary);
        font-size: font-size(very-normal);
    }
    .items-shipping-modal .nav-link div {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .items-shipping-modal .nav-link {
        padding: 6px;
    }
    .items-shipping-modal .arrow {
        display: none;
    }
    .items-shipping-modal .making-zone .list span{
        color: vt-color(dark-text);
    }
    .items-shipping-modal .making-zone .list {
        height: 240px;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .items-shipping-modal .making-zone .list.large-list {
        height: 300px;
    }
    .items-shipping-modal .making-zone .header-row {
        position: sticky;
        top: 0;
        background: #FFF;
        z-index: 1;
    }
    .items-shipping-modal .making-zone .element-row {
        border-bottom: 1px solid vt-color(grid-general-border);
        padding: 7px 0;
    }
    .items-shipping-modal .making-zone .element-row:hover {
        background: vt-color(light-primary);
    }
    .items-shipping-modal .tabs {
        border: 1px solid vt-color(grid-general-border);
        display: grid;
        grid-template-columns: 1fr 7fr;
    }
    .items-shipping-modal .tabs .col-auto {
        height: 325px;
        display: grid;
        overflow: auto;
        min-width: 190px;
    }
    .items-shipping-modal .tab-content {
        border-left: 1px solid vt-color(grid-general-border);
    }
    .items-shipping-modal .tabs ul {
        padding: 5px;
    }
    .items-shipping-modal .tabs .nav-item {
        background: #FFF;
        box-shadow: 0 1px 1px 0 rgba(141, 141, 143, 0.3);
        border: 1px solid #dee2e6;
        border-radius: 5px;
        margin-bottom: 5px;
        font-size: font-size(small);
    }
    .items-shipping-modal .tabs .nav-item:hover {
        background: vt-color(light-primary);
    }
    .items-shipping-modal .nav-pills {
        min-width: 190px;
    }
    .return-pop {
        padding: 0 !important;
    }
    .return-pop ul {
        padding: 0;
        margin: 5px 0;
    }
    .return-pop ul li {
        list-style: none;
        padding: 2px 20px;
        font-size: 12px;
    }
    .return-pop ul li:hover {
        background: vt-color(light-primary);
    }
    .return-pop .pop-header {
        background: vt-color(base-text, .9);
        padding: 8px 12px;
        font-weight: 700;
    }
    .context-header {
        background: vt-color(base-text, .9);
        padding: 6px 20px;
        font-weight: 700;
        margin-bottom: 5px;
    }
    .items-shipping-modal .ctx-menu {
        padding-top: 0;
    }
    .items-shipping-modal .shipping-box {
        margin: 10px 6px;
        border: 1px solid vt-color(base-text, .5);
        border-radius: 4px;
        box-shadow: 0 1px 1px 0 rgba(141, 141, 143, 0.3);
        border-left: 3px solid vt-color(primary);
    }
    .shipping-box .title {
        color: vt-color(primary);
    }

    @media (max-width: 1300px) {
        .items-shipping-modal .modal-dialog {
            max-width: 75% !important;
        }
        .elements-column {
            height: calc(100vh - 590px);
        }
    }

    @media only screen and (max-width: 1366px) and (min-width: 1360px) {
        .items-shipping-modal .modal-dialog {
            max-width: 70% !important;
        }
        .elements-column {
            height: calc(100vh - 330px);
        }
    }
</style>
